import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import CleaveInput from 'cleave.js/react';
import InputBase from '../InputBase';
var TextInput = function TextInput(props) {
  return /*#__PURE__*/React.createElement(InputBase, _extends({}, props, {
    inputComponent: CleaveInput
  }));
};
TextInput.defaultProps = {
  options: {
    delimiter: ''
  }
};

/* eslint-disable react/forbid-prop-types */
process.env.NODE_ENV !== "production" ? TextInput.propTypes = {
  options: PropTypes.object
} : void 0;
export default TextInput;